import {Routes} from "@angular/router";
import {AuthGuardService} from "../fonzie/auth/auth-guard.service";
import {UserSearchPageComponent} from "../fonzie/user/user-search/user-search-page.component";
import {UserEditPageComponent} from "../fonzie/user/user-edit/user-edit-page.component";
import {InvoiceReportPageComponent} from "../fonzie/report/invoice-report/invoice-report-page.component";
import {CustomerInstanceEditPageComponent} from "../fonzie/customer-instance/customer-instance-edit/customer-instance-edit-page.component";
import {CustomerInstanceSearchPageComponent} from "../fonzie/customer-instance/customer-instance-search/customer-instance-search-page.component";
import {CustomerInstanceVenueEditPageComponent} from "../fonzie/customer-instance-venue/customer-instance-venue-edit/customer-instance-venue-edit-page.component";
import {CustomerInstanceVenueSearchPageComponent} from "../fonzie/customer-instance-venue/customer-instance-venue-search/customer-instance-venue-search-page.component";
import {VenueSyncPaymentsSearchPageComponent} from "../fonzie/venue-sync/venue-sync-payments-search/venue-sync-payments-search-page.component";
import {CustomerInstanceVenueManagerSearchPageComponent} from "../fonzie/customer-instance-venue/customer-instance-venue-manager-search/customer-instance-venue-manager-search-page.component";
import {RoutingPageComponent} from "./routing-page.component";
import {PartnerSearchPageComponent} from "../fonzie/partner/partner-search/partner-search-page.component";
import {PartnerEditPageComponent} from "../fonzie/partner/partner-edit/partner-edit-page.component";
import {VenueSignupReportPageComponent} from "../fonzie/report/venue-signup-report/venue-signup-report-page.component";
import {
    CustomerInstanceGroupSearchPageComponent
} from "../fonzie/customer-instance-group/customer-instance-group-search/customer-instance-group-search-page.component";
import {
    CustomerInstanceGroupEditPageComponent
} from "../fonzie/customer-instance-group/customer-instance-group-edit/customer-instance-group-edit-page.component";
import {PlanUpdateBatchJobPageComponent} from "../fonzie/batch/plan-update-batch-job/plan-update-batch-job-page.component";
import {BackupPageComponent} from "../fonzie/admin/backup/backup-page.component";

export const MainRoutes: Routes = [

    {
        component: UserSearchPageComponent,
        path: "user-search",
        canActivate: [AuthGuardService]
    },
    {
        component: PartnerSearchPageComponent,
        path: "partner-search",
        canActivate: [AuthGuardService]
    },
    {
        component: PartnerEditPageComponent,
        path: "partner-edit",
        canActivate: [AuthGuardService]
    },
    {
        component: UserEditPageComponent,
        path: "user-edit/:id",
        canActivate: [AuthGuardService]
    },
    {
        component: CustomerInstanceGroupSearchPageComponent,
        path: "customer-instance-group-search",
        canActivate: [AuthGuardService]
    },
    {
        component: CustomerInstanceGroupEditPageComponent,
        path: "customer-instance-group-edit/:id",
        canActivate: [AuthGuardService]
    },
    {
        component: CustomerInstanceSearchPageComponent,
        path: "customer-instance-search/:type",
        canActivate: [AuthGuardService]
    },
    {
        component: CustomerInstanceEditPageComponent,
        path: "customer-instance-edit/:id",
        canActivate: [AuthGuardService]
    },
    {
        component: CustomerInstanceVenueEditPageComponent,
        path: "customer-instance-venue-edit/:venueId",
        canActivate: [AuthGuardService]
    },
    {
        component: CustomerInstanceVenueSearchPageComponent,
        path: "customer-instance-venue-search",
        canActivate: [AuthGuardService]
    },
    {
        component: CustomerInstanceVenueManagerSearchPageComponent,
        path: "sales-signup-search",
        canActivate: [AuthGuardService]
    },
    {
        component: InvoiceReportPageComponent,
        path: "invoices-report/:type",
        canActivate: [AuthGuardService]
    },
    {
        component: VenueSignupReportPageComponent,
        path: "venue-signup-report",
        canActivate: [AuthGuardService]
    },
    {
        component: PlanUpdateBatchJobPageComponent,
        path: "plan-update-batch-job",
        canActivate: [AuthGuardService]
    },
    {
        component: VenueSyncPaymentsSearchPageComponent,
        path: "venue-sync-payments-search",
        canActivate: [AuthGuardService]
    },
    {
        component: BackupPageComponent,
        path: "backup",
        canActivate: [AuthGuardService]
    },
    {
        component: RoutingPageComponent,
        path: "routing-page",
        canActivate: [AuthGuardService]
    },
    {
        path: "",
        pathMatch: "full",
        redirectTo: "routing-page"
    }
];
